/**
 * Base API URL for backend services
 */
// export const API_URL = 'http://localhost:3022/api/v1';
export const API_URL = 'https://api.travelpradesh.in/api/v1';